/**
 * description: 原子权限模板指令 
 * created by he.zhikai 
 * created on 2017-11-19  
 */
"use strict";
angular.module("manageCfg.roleManageMent.permissionAssignment.authorityTemplateModule", [])
    .directive('authorityTemplateDir', ["trsHttpService", "modalDialog",
        function(trsHttpService, modalDialog) {
            return {
                restrict: 'AE',
                scope: {
                    selectTemplate: "=",
                    callback: "&"
                },
                templateUrl: "./manageConfig/roleManageMent/permissionAssignment/directives/authorityTemplate_tpl.html",
                link: function(scope, iElement, iAttrs) {
                    initStatus();
                    initData();

                    /**
                     * [initStatus description] 初始化状态
                     * @return {[type]} [description]
                     */
                    function initStatus() {
                        scope.data = {
                            templateList: []
                        };
                        scope.$on("savaPerSuccess", function(event, data) {
                            loadAuthorityTemplate();
                        });
                    }
                    /**
                     * [setPlaceHolder description] 设置placeholder
                     */
                    scope.setPlaceHolder = function(){
                        return scope.data.selectedTemplate?scope.data.selectedTemplate.RIGHTTEMPLATENAME:'请选择模板';
                    };
                    /**
                     * [initData description] 初始化数据
                     * @return {[type]} [description]
                     */
                    function initData() {
                        loadAuthorityTemplate();
                    }

                    /**
                     * [loadAuthorityTemplate description] 加载原子权限模板
                     * @return {[type]} [description]
                     */
                    function loadAuthorityTemplate() {
                        var params = {
                            "serviceid": "mlf_righttemplate",
                            "methodname": "queryRightTemplate",
                        };
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                            scope.data.templateList = data.DATA?data.DATA:data;
                        });
                    }

                    /**
                     * [setSelected description] 选中模板
                     * @param {[type]} template [description]
                     */
                    scope.setSelected = function(template) {
                        scope.data.selectedTemplate = template;
                        if (template.RIGHTTEMPLATEID !== "") {
                            scope.selectTemplate = template;
                            scope.callback();
                        }
                    };

                    /**
                     * [deleteTemplate description] 删除原子权限模板
                     * @param  {[type]} template [description] 当前模板
                     * @param  {[type]} index    [description] 模板序号
                     * @return {[type]}          [description]
                     */
                    scope.deleteTemplate = function(template, index, ev) {
                        ev.stopPropagation();
                        var params = {
                            "serviceid": "mlf_righttemplate",
                            "methodname": "deleteRightTemplate",
                            "tempId": template.RIGHTTEMPLATEID
                        };
                        modalDialog.alertType("确定删除\"" + template.RIGHTTEMPLATENAME + "\"模板么？", "", "warning", true, function(isConfirm) {
                            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                                scope.data.templateList.splice(index, 1);
                                if (scope.data.selectedTemplate == template) {
                                    scope.data.selectedTemplate = scope.data.templateList[0];
                                }
                                modalDialog.alertType("","模板删除成功","success",false,function(){});
                            });
                        });
                    };

                }
            };
        }
    ]);